var React = require('react');

function FaceId (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2,23.4V12A10,10,0,0,1,12,2H22.84","key":0}),React.createElement("path",{"d":"M52.72,2h11.4a10,10,0,0,1,10,10V22.84","key":1}),React.createElement("path",{"d":"M74.12,54V65.4a10,10,0,0,1-10,10H53.28","key":2}),React.createElement("path",{"d":"M23.4,75.4H12a10,10,0,0,1-10-10V54.56","key":3}),React.createElement("line",{"x1":"21.72","y1":"23.77","x2":"21.72","y2":"31.95","key":4}),React.createElement("line",{"x1":"52.72","y1":"23.77","x2":"52.72","y2":"31.95","key":5}),React.createElement("path",{"d":"M39.21,25.81V41.63s.56,3.9-5.21,3.9","key":6}),React.createElement("path",{"d":"M25.26,53.35s12.27,12.46,25.11.18","key":7})]);
}

FaceId.defaultProps = {"className":"svg-face-id","viewBox":"0 0 76.12 77.4","stroke":"#000000","fill":"none"};

module.exports = FaceId;

FaceId.default = FaceId;
